import { Route } from '@angular/router'
import { authGuard, permissionGuard } from '@baboor/baboor-auth'
import { PERMISSIONS } from '@baboor/baboor-models'
import { PageLayout, setLayout } from '@baboor/common-page-layouts'

export type ReferralRoutes = {
    referral: Route
}

export const referralRoutes: ReferralRoutes = {
    referral: {
        path: 'dashboard/referral',
        canActivate: [
            authGuard({ redirectTo: ['/login'] }),
            permissionGuard([PERMISSIONS.promotion.read], {
                redirectTo: ['/dashboard/home'],
            }),
        ],
        loadComponent: () =>
            import('../page-referral/page-referral.component').then(
                (m) => m.PageReferralComponent,
            ),
        resolve: { layout: setLayout(PageLayout.VendorDefault) },
    },
}
